export default __webpack_public_path__ + "static/media/warning--playground--g3.030a0910.png";